import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { DropdownTooltip } from '@brg/ui';
import { useTheme } from 'styled-components';
import { IconWrapper } from "../../assets/styles";

enum MoreButtonSize {
  large= 'large',
  regular = 'regular',
  small = 'small'
}

export const MoreButtonWrapper = styled(IconWrapper)<{ size: string }>`
    margin: ${({size}) => size === MoreButtonSize.large ? '4px 0 0' : 'inherit'};
  & svg {
    * {
      fill: ${({ theme: { icon }, pressed }) => pressed ? icon.active : icon.default}
    }

    :hover {
      * {
        fill: ${({ theme }) => theme.icon.hover};
      }
    }

    :active {
      * {
        fill: ${({ theme }) => theme.icon.active};
      }
    }
  }
`;

interface MoreButtonProps extends PropsWithChildren<unknown> {
  size?: string,
  orientation?: string,
  onClick?: () => void;
}

export const MoreButton: FC<MoreButtonProps> = ({
  children ,
  size= MoreButtonSize.regular,
  onClick
}) => {
    const theme = useTheme();
    return (
            <DropdownTooltip
                target={
                    <MoreButtonWrapper onClick={onClick} size={size}>
                      {size === MoreButtonSize.small && (
                        <svg className={'moreIcon'} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5681 7C14.3589 7 15 7.67157 15 8.5C15 9.32843 14.3589 10 13.5681 10C12.7773 10 12.1362 9.32843 12.1362 8.5C12.1362 7.67157 12.7773 7 13.5681 7Z" fill="#909090"/>
                        <path d="M8.0028 7C8.7936 7 9.43468 7.67157 9.43468 8.5C9.43468 9.32843 8.7936 10 8.0028 10C7.21199 10 6.57091 9.32843 6.57091 8.5C6.57091 7.67157 7.21199 7 8.0028 7Z" fill="#909090"/>
                        <path d="M2.43188 7C3.22269 7 3.86376 7.67157 3.86376 8.5C3.86376 9.32843 3.22269 10 2.43188 10C1.64108 10 1 9.32843 1 8.5C1 7.67157 1.64108 7 2.43188 7Z" fill="#909090"/>
                        </svg>
                        
                      )}
                      {size === MoreButtonSize.regular && (
                          <svg
                              className={'moreIcon'}
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                              <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C6.10457 14 7 13.1046 7 12ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10Z"
                                  fill={theme.tags.textColor}
                              />
                          </svg>
                          
                      )}
                      {size === MoreButtonSize.large && (
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 23.9545C18 25.0842 17.1046 26 16 26C14.8954 26 14 25.0842 14 23.9545C14 22.8247 14.8954 21.9089 16 21.9089C17.1046 21.9089 18 22.8247 18 23.9545Z" fill={theme.projectView.viewCardStroke} />
                          <path d="M18 16.004C18 17.1337 17.1046 18.0495 16 18.0495C14.8954 18.0495 14 17.1337 14 16.004C14 14.8743 14.8954 13.9584 16 13.9584C17.1046 13.9584 18 14.8743 18 16.004Z" fill={theme.projectView.viewCardStroke} />
                          <path d="M18 8.04555C18 9.17527 17.1046 10.0911 16 10.0911C14.8954 10.0911 14 9.17527 14 8.04555C14 6.91582 14.8954 6 16 6C17.1046 6 18 6.91582 18 8.04555Z" fill={theme.projectView.viewCardStroke} />
                        </svg>
                      )}
                    </MoreButtonWrapper>
                }
            >
                <>{children}</>
            </DropdownTooltip>
    );
};
import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { DropdownTooltip } from '@brg/ui';
import { useTheme } from 'styled-components';
import { IconWrapper } from "../../assets/styles";

enum MoreButtonSize {
  large= 'large',
  regular = 'regular',
  small = 'small'
}

export const MoreButtonWrapper = styled(IconWrapper)<{ size: string }>`
    margin: ${({size}) => size === MoreButtonSize.large ? '4px 0 0' : 'inherit'};
  & svg {
    * {
      fill: ${({ theme: { icon }, pressed }) => pressed ? icon.active : icon.default}
    }

    :hover {
      * {
        fill: ${({ theme }) => theme.icon.hover};
      }
    }

    :active {
      * {
        fill: ${({ theme }) => theme.icon.active};
      }
    }
  }
`;

interface MoreButtonProps extends PropsWithChildren<unknown> {
  size?: string,
  orientation?: string,
  onClick?: () => void;
}

export const MoreButton: FC<MoreButtonProps> = ({
  children ,
  size= MoreButtonSize.regular,
  onClick
}) => {
    const theme = useTheme();
    return (
            <DropdownTooltip
                target={
                    <MoreButtonWrapper onClick={onClick} size={size}>
                      {size === MoreButtonSize.small && (
                        <svg className={'moreIcon'} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5681 7C14.3589 7 15 7.67157 15 8.5C15 9.32843 14.3589 10 13.5681 10C12.7773 10 12.1362 9.32843 12.1362 8.5C12.1362 7.67157 12.7773 7 13.5681 7Z" fill="#909090"/>
                        <path d="M8.0028 7C8.7936 7 9.43468 7.67157 9.43468 8.5C9.43468 9.32843 8.7936 10 8.0028 10C7.21199 10 6.57091 9.32843 6.57091 8.5C6.57091 7.67157 7.21199 7 8.0028 7Z" fill="#909090"/>
                        <path d="M2.43188 7C3.22269 7 3.86376 7.67157 3.86376 8.5C3.86376 9.32843 3.22269 10 2.43188 10C1.64108 10 1 9.32843 1 8.5C1 7.67157 1.64108 7 2.43188 7Z" fill="#909090"/>
                        </svg>
                        
                      )}
                      {size === MoreButtonSize.regular && (
                          <svg
                              className={'moreIcon'}
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                              <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14C6.10457 14 7 13.1046 7 12ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10ZM19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14C17.8954 14 17 13.1046 17 12C17 10.8954 17.8954 10 19 10Z"
                                  fill={theme.tags.textColor}
                              />
                          </svg>
                          
                      )}
                      {size === MoreButtonSize.large && (
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18 23.9545C18 25.0842 17.1046 26 16 26C14.8954 26 14 25.0842 14 23.9545C14 22.8247 14.8954 21.9089 16 21.9089C17.1046 21.9089 18 22.8247 18 23.9545Z" fill={theme.projectView.viewCardStroke} />
                          <path d="M18 16.004C18 17.1337 17.1046 18.0495 16 18.0495C14.8954 18.0495 14 17.1337 14 16.004C14 14.8743 14.8954 13.9584 16 13.9584C17.1046 13.9584 18 14.8743 18 16.004Z" fill={theme.projectView.viewCardStroke} />
                          <path d="M18 8.04555C18 9.17527 17.1046 10.0911 16 10.0911C14.8954 10.0911 14 9.17527 14 8.04555C14 6.91582 14.8954 6 16 6C17.1046 6 18 6.91582 18 8.04555Z" fill={theme.projectView.viewCardStroke} />
                        </svg>
                      )}
                    </MoreButtonWrapper>
                }
            >
                <>{children}</>
            </DropdownTooltip>
    );
};
